const ANONYMOUS_ID_KEY = 'kiubo.analytics.anonymous_id';
const SESSION_ID_KEY = 'kiubo.analytics.session_id';

function createId(): string {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function getOrCreateStorageValue(storage: Storage, key: string): string {
  try {
    const existingValue = storage.getItem(key);
    if (existingValue) {
      return existingValue;
    }

    const newValue = createId();
    storage.setItem(key, newValue);
    return newValue;
  } catch {
    return createId();
  }
}

export function getAnalyticsAnonymousId(): string {
  return getOrCreateStorageValue(localStorage, ANONYMOUS_ID_KEY);
}

export function getAnalyticsSessionId(): string {
  return getOrCreateStorageValue(sessionStorage, SESSION_ID_KEY);
}

export function createAnalyticsId(): string {
  return createId();
}
